import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { AgreementInterface } from 'src/shared/entities/agreement/agreement.schema'
import { generateEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export const createAgreement = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): AgreementInterface => {
  return {
    ...generateEntity(EntityTypeEnum.Agreement, parentId, masterBlockId),
  }
}
